declare global {
  interface Window {
    CustomEvent: typeof CustomEvent
  }
}

if (typeof window.CustomEvent !== 'function') {
  function CustomEvent <T> (event: string, params?: CustomEventInit<T>): CustomEvent<T> {
    params = Object.assign({
      bubbles: false,
      cancelable: false,
      detail: undefined
    }, params || {})

    const evt = document.createEvent('CustomEvent')

    evt.initCustomEvent(
      event,
      params.bubbles || false,
      params.cancelable || false,
      params.detail
    )

    return evt
  }

  CustomEvent.prototype = Event.prototype

  // @ts-ignore
  window.CustomEvent = CustomEvent
}

export {}
